import AntiEpidemic from '../../configs/header/desktop/anti-epidemic';
import Emergency from '../../configs/header/desktop/emergency';
import FindADoctor from '../../configs/header/desktop/find-a-doctor';
import FindDocCare from '../../configs/header/desktop/finddoc-care';
import FindDocClub from '../../configs/header/desktop/finddoc-club';
import Health from '../../configs/header/desktop/health';
import MobileData from '../../configs/header/mobile/data';
import { env } from '../env';

export default (cms) => ({
    desktop: [
        FindADoctor,
        // AntiEpidemic,
        Health(cms),
        Emergency,
        (env.mode === 'development') ? FindDocCare : {},
        FindDocClub,
    ] as any[],
    mobile: MobileData(cms),
});